// Is the signed-in person on a sourcing team (staff, or a member of a roster
// marked for the job pool)? The sidebar shows "Job pool" only then. One call
// per session, remembered per user, so a page load never waits on it twice.
import { useEffect, useState } from 'react';
import RequirementsV2API from '../api/requirementsV2.js';

const KEY = (userId) => `sourcing_access_${userId}`;

export function useSourcingAccess(userId) {
  const [allowed, setAllowed] = useState(() => {
    if (!userId) return false;
    try { return sessionStorage.getItem(KEY(userId)) === '1'; } catch { return false; }
  });
  useEffect(() => {
    if (!userId) { setAllowed(false); return undefined; }
    let live = true;
    // The sidebar calls this on every signed-in page, so it must never be the
    // thing that takes a page down. `.catch` only sees a rejected promise; a
    // synchronous throw — the method missing from a stale API module after a
    // deploy, which blanked /admin/console on 2026-09-14 — escapes it and
    // reaches the error boundary. Start the call inside the promise instead,
    // so every failure is a rejection and the answer is simply "no".
    Promise.resolve()
      .then(() => RequirementsV2API.sourcingAccess())
      .then((a) => {
        if (!live) return;
        const ok = !!a?.allowed;
        setAllowed(ok);
        try { sessionStorage.setItem(KEY(userId), ok ? '1' : '0'); } catch { /* storage blocked */ }
      })
      .catch(() => {});
    return () => { live = false; };
  }, [userId]);
  return allowed;
}
